<template>
  <div class="paper-warp">
    <table class="cert-table" border="0">
      <tr
        v-for="(item, index) in certData"
        :key="index"
        class="cert-tr"
        :class="item.label == '类别/工种' ? 'cert-tr-spec' : ''"
      >
        <td class="cert-td-1">{{ item.label }}</td>
        <td class="cert-td-2">{{ item.value }}</td>
      </tr>
    </table>
    <div class="remark">*修完全部教学课程，考试成绩合格，准允结业！</div>
  </div>
</template>

<script>
import { CertDetail } from '@/api/index'
const sortArr = [
  {
    label: '姓名',
    key: 'student_name',
  },
  {
    label: '性别',
    key: 'sex',
  },
  {
    label: '身份证号码',
    key: 'idcard',
  },
  {
    label: '学历',
    key: 'diploma',
  },
  {
    label: '类别/工种',
    key: 'cert_occupation',
  },
  {
    label: '理论考试成绩',
    key: 'theory_score',
  },
  {
    label: '实操考试成绩',
    key: 'practical',
  },
  {
    label: '工作单位',
    key: 'cert_company',
  },
  {
    label: '等级/岗位',
    key: 'cert_post',
  },
  {
    label: '证书编号',
    key: 'cert_no',
  },
  {
    label: '培训日期',
    key: 'training_interval',
  },
  {
    label: '发证日期',
    key: 'cert_date',
  },
  {
    label: '有效期',
    key: 'expiration',
  },
]
export default {
  name: 'CertificateTable',
  data() {
    return {
      sortObj: {},
      data: {},
      certData: {},
    }
  },
  computed: {},
  watch: {},
  created() {
    this.initSort()
    if (this.$route.query.id) {
      this.initPage(this.$route.query.id)
    } else {
      var obj = {}
      var query = window.location.href.split('?')[1]
      var vars = query.split('&')
      if (vars.length !== 0) {
        var pair = null
        for (var i = 0; i < vars.length; i++) {
          pair = vars[i].split('=')
          obj[pair[0]] = pair[1]
        }
        this.initPage(obj.id)
      }
    }
  },
  methods: {
    initSort() {
      // 定义序号
      const sortObj = {}
      sortArr.map((item, index) => {
        item.sort = index + 1
        sortObj[item.key] = item
      })
      this.sortObj = sortObj
    },
    async initPage(id) {
      if (!id) return
      const res = await CertDetail({
        id: this.$route.query.id,
      })
      this.data = res
      // const certData = res.cert_data.map((item) => {
      //   item.sort = this.sortObj[item.label] || 100
      //   return item
      // })
      const certData = []
      for (const key in res.cert_data) {
        certData.push({
          label: this.sortObj[key].label || '未知项',
          value: res.cert_data[key],
          sort: this.sortObj[key].sort || 100,
        })
      }
      // 按序排列
      this.certData = certData.sort((a, b) => {
        return a.sort - b.sort
      })
      // console.log('this.data', this.data, this.certData)
      // this.setComplexData()
    },
    setComplexData() {
      const certData = this.certData
      const data = []
      // const listLeft = []
      certData.map((item) => {
        switch (item.label) {
          case '性别':
            this.dataObj.sex = item
            break
          case '姓名':
            this.dataObj.name = item
            break
          case '发证日期':
            this.dataObj.date = item
            break
          case '发证机构名称及公章':
            this.dataObj.agency = item
            break
          case '出生日期':
            var birthday = {}
            var dayArr = item.value
              .replace('年', '-')
              .replace('月', '-')
              .replace('日', '-')
              .split('-')
            birthday.year = dayArr[0]
            birthday.month = dayArr[1]
            birthday.day = dayArr[2]
            this.dataObj.birthday = birthday
            data.push(item)
            break
          default:
            data.push(item)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.paper-warp {
  width: 100vw;
  height: 100%;
  position: relative;
  overflow-y: auto;
  padding: 12px;
}
.cert-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  border-right: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  td {
    padding: 5px 0;
    border-left: 1px solid #e1e1e1;
    border-top: 1px solid #e1e1e1;
  }
  .cert-tr {
    display: flex;
  }
  .cert-tr-spec {
    background: #d7e9f4;
  }
  .cert-td-1 {
    flex: 1;
  }
  .cert-td-2 {
    flex: 2;
  }
}
.remark {
  font-size: 12px;
  margin-top: 8px;
  color: #888;
  width: 100%;
  text-align: end;
}
</style>
